import {ViziblyTheme} from "../analyst/ViziblyZDGTheme";
import FeatureRestrictedOverlay from "../../components/feature-restricted-overlay/FeatureRestrictedOverlay";
import {Col, Grid, Row} from "@zendeskgarden/react-grid";
import * as css from "./styles/payrollSettings.module.scss";
import {ThemeProvider} from "@zendeskgarden/react-theming";
import {AdminWrapper} from "../admin/AdminWrapper";
import {ReactElement, useContext, useMemo, useState} from "react";
import {useListUserClientsQuery} from "../../__generated__/generated_types";
import {AuthContext} from "../../contexts/AuthContext";
import {Tab, TabList, TabPanel, Tabs} from "@zendeskgarden/react-tabs";
import {PayrollFrequencySettings} from "./PayrollFrequencySettings";
import {PayrollSettingsCompItems} from "./PayrollSettingsCompItems";

export function PayrollSettings(): ReactElement {
    const auth = useContext(AuthContext);
    const {data: clients, loading: clientsLoading} = useListUserClientsQuery({
        fetchPolicy: "no-cache"
    });

    const [selectedTab, setSelectedTab] = useState<"frequency" | "compItems">("frequency");

    // Let's make sure user understands that this setting is independent for each workspace (client)
    const clientName = useMemo(() => {
        if(!clients || clientsLoading) {
            return undefined;
        }
        if(clients.listUserClients.length == 1) {
            return undefined;
        }
        return auth.user?.clientName; // do not use clientDisplayName here because it will not always distinct between workspaces for the same client
    }, [clients, clientsLoading, auth.user?.clientId]);

    return <AdminWrapper>
        <ThemeProvider theme={ViziblyTheme}>
            <FeatureRestrictedOverlay coverPage />
            <Grid>
                <Row>
                    <Col>
                        <h3 className={css.pageTitle}>Payroll Settings{clientName ? ` for ${clientName}` : ""}</h3>
                    </Col>
                </Row>
            </Grid>
            <Tabs selectedItem={selectedTab} onChange={setSelectedTab}>
                <TabList>
                    <Tab item="frequency">Payroll Frequency</Tab>
                    <Tab item="compItems">Compensation Items</Tab>
                </TabList>
                <TabPanel item="frequency">
                    {selectedTab === "frequency" &&
                        <PayrollFrequencySettings />
                    }
                </TabPanel>
                <TabPanel item="compItems">
                    {selectedTab === "compItems" &&
                        <PayrollSettingsCompItems />
                    }
                </TabPanel>
            </Tabs>
        </ThemeProvider>
    </AdminWrapper>;
}